import { Component } from "react"

/* Components */
import Layout from "./Layout"


/* Component InnerLayout — the same states drawn on a light background inside a page */
class InnerLayout extends Component {

    render = () => {
        return <Layout {...this.props} light />
    }

}

export default InnerLayout
